import { type CurrentUser } from '@repo/api-client';

import { useSessionStore, type SessionStatus } from '../session.store';

/** Current authentication status. */
export function useSessionStatus(): SessionStatus {
  return useSessionStore((state) => state.status);
}

/** The signed-in user, or `null` if the session isn't established yet. */
export function useCurrentUser(): CurrentUser | null {
  return useSessionStore((state) => state.user);
}

/**
 * The signed-in user, guaranteed non-null.
 *
 * Reserved for components rendered under `<RequireAuth>`, which already
 * eliminated the `null` case.
 */
export function useAuthenticatedUser(): CurrentUser {
  const user = useCurrentUser();
  if (!user) {
    throw new Error(
      'useAuthenticatedUser() outside a session. This component must render under <RequireAuth>.',
    );
  }
  return user;
}
